import { useCafAnalysisComponentDetailV5 } from '../../../../../modules/apis/webview/caf'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import PronunciationIntroSection from '../../../../new-portal/caf/analysis/pronunciation/PronunciationIntroSection'
import PronunciationTabsSection from '../../../../new-portal/caf/analysis/pronunciation/PronunciationTabsSection'
import ThickDivider from '../../../../new-portal/caf/common/ThickDivider'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIPronunciationActivity = ({ params }) => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop } = useConversationAIFlow()
  const { threadId, componentId } = params
  const { t } = useTranslation()
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId)

  return (
    <div>
      <WebviewStackContainer
        height="52px"
        onBack={pop}
        title={
          <div className="flex flex-row items-center justify-start text-[18px] text-black">
            {t(n_caf.overview.pronunciation)}
            <div className="ml-[8px] rounded-[4px] bg-red-50 px-[6px] py-[2px] text-[10px] font-bold text-red-400">
              Beta
            </div>
          </div>
        }
        border={true}
      >
        {isLoading ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="keep-all min-h-screen overflow-hidden text-gray-700">
            <PronunciationIntroSection componentId={componentId} />
            <ThickDivider />
            <div className="bg-gray-50">
              <div className="h-16" />
              <PronunciationTabsSection componentId={componentId} />
              <div className="h-[61px]" />
            </div>
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIPronunciationActivity
